import React from 'react';
import styles from './StrategyCard.module.scss';
import shieldIcon from '../../../assets/icons/shield.svg';
import shieldTickIcon from '../../../assets/icons/shield-tick.svg';
import shieldKeyIcon from '../../../assets/icons/shield-key.svg';
import ArrowIcon from '../ArrowIcon/ArrowIcon';

const StrategyCard = ({ card, isSelected, isRecommended, onSelect }) => {
  const cardClasses = `
    ${styles.card}
    ${isSelected ? styles.selected : ''}
    ${isRecommended ? styles.recommended : ''}
  `;

  let icon;
  switch (card.id) {
    case 'minimal':
      icon = shieldIcon;
      break;
    case 'medium':
      icon = shieldTickIcon;
      break;
    case 'maximal':
      icon = shieldKeyIcon;
      break;
    default:
      icon = shieldIcon;
  }

  return (
    <div className={cardClasses} onClick={() => onSelect(card.id)}>
      {isRecommended && (
        <div className={styles.recommendedWrapper}>
          <div className={styles.recommendedBadge}>Рекомендуємо</div>
          <svg width="144" height="67" viewBox="0 0 144 67" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M144 67H142V51C142 42.1634 134.837 35 126 35H36C27.1634 35 20 27.8366 20 19V18C20 9.16345 12.8365 2.00001 4 2H0V0H144V67Z" fill="url(#paint0_linear_83_6037)"/>
            <defs>
              <linearGradient id="paint0_linear_83_6037" x1="2.51895" y1="2.0446" x2="119.129" y2="97.4115" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FC5413"/>
                <stop offset="1" stopColor="#ED3A09"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
      )}
      
      <div className={styles.iconWrapper}>
        <div className={`${styles.decoCircle} ${styles.size10}`}></div>
        <div className={`${styles.decoCircle} ${styles.size20}`}></div>
        <div className={`${styles.decoCircle} ${styles.size72}`}>
            <div className={`${styles.decoCircle} ${styles.size56}`}>
                <img src={icon} alt="" className={styles.icon} />
            </div>
        </div>
        <div className={`${styles.decoCircle} ${styles.size20}`}></div>
        <div className={`${styles.decoCircle} ${styles.size10}`}></div>
      </div>

      <div className={styles.contentWrapper}>
        <h3 className={styles.cardTitle}>{card.title}</h3>
        <p className={styles.cardDescription}>{card.description}</p>
        <p className={styles.classInfo}>Кількість класів: {card.classCount}</p>

        <ul className={styles.classList}>
          {card.classes.map((item, index) => {
            const parts = item.split(':');
            const classNum = parts[0] + ':';
            const classDesc = parts.slice(1).join(':');
            return (
              <li key={index} className={styles.classItem}>
                <div className={styles.arrowIconWrapper}>
                  <ArrowIcon color={isSelected ? 'white' : '#ed3a09'} />
                </div>
                <span>
                  <strong>{classNum}</strong>
                  {classDesc}
                </span>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  );
};

export default StrategyCard;